import type { PartnerProductInsightsAPIProduct } from 'src/services/partner-product-insights-api/types/PartnerProductInsightsAPIProduct';
import type { ReviewsSummaryProductInsights } from '../types';

export const adaptProductInsightsToStore = (
  response: PartnerProductInsightsAPIProduct,
): ReviewsSummaryProductInsights => {
  const wasTheProductAsAdvertised = response.scores?.wasTheProductAsAdvertised;

  return {
    scores: {
      ...(wasTheProductAsAdvertised
        ? {
            wasTheProductAsAdvertised: {
              score: wasTheProductAsAdvertised.score,
              totalResponses: wasTheProductAsAdvertised.total_responses,
            },
          }
        : {}),
    },
  };
};
